
import {Component, OnInit, ViewChild} from '@angular/core';
import {TsaService} from '../_services/tsa.service';
import {formatDate} from '@angular/common';
import {Globals} from '../globals';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  @ViewChild('chart') chart: any;
  yoyData: any = [];

  chartOptions: any;
  width = "90vw";
  height = "80vh";
  loading = false;
  startDate: Date = new Date(new Date('2023-01-01').getTime() + new Date('2023-01-01').getTimezoneOffset()*60000);
  // Need to use time zone offset in the same day. Otherwise, the daylight saving time may create a difference
  endDate: Date = new Date(new Date().getTime() + new Date().getTimezoneOffset()*60000);
  startDateStr: string = '2023-01-01';
  endDateStr: string | null;


  /**
   * Set up default values
   * @param service - service for getting YOY chart data
   */
  constructor(private service: TsaService, private globals: Globals) {

    this.startDateStr = formatDate(this.startDate, 'yyyy-MM-dd', 'en-US');
    this.endDateStr = formatDate(this.endDate, 'yyyy-MM-dd', 'en-US');

    // Set up chart options
    this.chartOptions = this.globals.chartOptions;

  }

  /**
   * Init function
   */
  ngOnInit(): void {
    // Get data for the first chart
    if(this.yoyData.length == 0) {
      this.updateService('/Public.action?sql=PUBLIC_TSA_YOY_THROUGHPUT');
    }
  }

  /**
   * Refresh data for the YOY chart
   * @param url - URL for getting the data
   */
  updateService(url: string): void {
    // Get data for the first chart
    this.service.url = url;
    this.loading = true;
    this.service.getData().subscribe((data: any[]) => {
      this.loading = false;
      const x = [];
      let y: any[] = [];
      let today = new Date();
      let firstYear = this.startDate.getFullYear();
      let lastYear = this.endDate.getFullYear();
      for (let i = firstYear; i <= lastYear; i++) {
        y.push(new Array());
      }
      if(data) {
        for (const item of data) {
          x.push(item.DATE);
          for (let i = firstYear; i <= lastYear; i++) {
            if ((new Date(item.DATE + ', ' + i + ' 23:59:59')).getTime()
              + new Date().getTimezoneOffset() * 60000 > today.getTime()) {
              y[i - firstYear].push(null);
            } else {
              y[i - firstYear].push(item['Y' + i]);
            }
          }
        }

        let ds = [];
        let myColors = ['#e6f5c9', '#1693e2'];
        if(lastYear > 2024) myColors = ['#BBE5BB','#FDDCA8', '#1f77b4'];

        for (let i = lastYear; i >= firstYear; i--) {
          ds.push({
            label: i.toString(),
            fill: false,
            data: y[i - firstYear],
            borderColor: myColors[i - firstYear]
          });
        }
        this.yoyData = {
          labels: x,
          datasets: ds
        };
      }
    });
  }

}
